import script from "./fcm.vue?vue&type=script&lang=js"
export * from "./fcm.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__